// @flow
import React, { Fragment } from 'react';
import classNames from 'classnames/bind';
import { Container, Row, Col } from 'Components/Grid';
import styles from './styles.scss';
import { getForeground, hasDarkBackground } from 'Utils/getColor';
import ConsumptionData from 'Components/ConsumptionData';
import Button from 'Components/Button';
import { getHrefWithoutQueries } from 'Utils';
import { lowerCase6e } from 'Utils/special/lowerCaseSpecial';
const cx = classNames.bind(styles);

type Background = 'white' | 'default';

type Link = {
  additional?: string,
  href?: string,
  label?: string,
  mazdaForm?: boolean,
  model?: string,
  type?: string,
  target?: string,
};

type Props = {
  id?: string,
  headline?: string,
  text?: string,
  children?: Node,
  background: Background,
  deeplinkId?: number,
  links: Array<Link>,
};

export default class LinkBox extends React.Component<Props> {
  static defaultProps = {
    background: 'default',
  };

  renderLink = (item) => {
    if (!item.link.label || item.link.label === '') {
      return null;
    }

    const darkBackground = hasDarkBackground(this.props.background);
    const hrefWithoutQueries = getHrefWithoutQueries(item.href);
    const isActive =
      window.location.href.includes(hrefWithoutQueries) && hrefWithoutQueries.length > 1;
    const locationAndTargetAreStartPage =
      hrefWithoutQueries === '/' && window.location.pathname === '/';

    // Sonderlocke: be explicit about the replacement (MAZ-2109)
    const hasSpecial = item.link.label.includes('6E') || item.link.label.includes('6e');
    const specialLabel = item.link.label.replaceAll('6E', '6e');

    return (
      <li key={item.link.label}>
        <Button
          label={specialLabel}
          upperCase={!hasSpecial}
          type="secondary"
          href={item.href || undefined}
          className={cx(styles.link, {
            activeLink: (locationAndTargetAreStartPage || isActive) && !darkBackground,
            activeLinkDark: (locationAndTargetAreStartPage || isActive) && darkBackground,
            darkBackground: darkBackground,
          })}
          light={darkBackground}
        />
        <span className={styles.pipe}>|</span>
      </li>
    );
  };

  render() {
    const { id, headline, background, deeplinkId, consumptionText, links } = this.props;

    return (
      <Fragment>
        <div id={deeplinkId || id} className={cx(styles.contentText, { [background]: true })}>
          <Container>
            <Row align="center">
              <Col cols={12} m={10} l={8}>
                {headline && (
                  <div
                    className={cx(styles.header, getForeground(background), {
                      [styles.overwritep]: hasDarkBackground(background),
                    })}
                    dangerouslySetInnerHTML={{ __html: lowerCase6e(headline) }}
                  />
                )}
              </Col>

              <Col cols={12} m={10} l={8}>
                <ul className={styles.linksContainer}>
                  {links.map((item) => this.renderLink(item))}
                </ul>
              </Col>
            </Row>
          </Container>
        </div>
        {consumptionText && <ConsumptionData consumptionText={[consumptionText]} />}
      </Fragment>
    );
  }
}
